module.exports = __webpack_public_path__ + "static/media/nav-my-documents-inquiries.05a9c08d.svg";